import * as React from "react";
const UseAi = (props) => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.82302 3.47828C4.88381 3.31399 5.11619 3.31399 5.17698 3.47828C5.75038 5.02787 6.97213 6.24962 8.52172 6.82302C8.68601 6.88381 8.68601 7.11619 8.52172 7.17698C6.97213 7.75038 5.75038 8.97213 5.17698 10.5217C5.11619 10.686 4.88381 10.686 4.82302 10.5217C4.24962 8.97213 3.02787 7.75038 1.47828 7.17698C1.31399 7.11619 1.31399 6.88381 1.47828 6.82302C3.02787 6.24962 4.24962 5.02787 4.82302 3.47828Z"
      fill="currentColor"
    />
    <path
      d="M8.82724 1.46687C8.88659 1.30649 9.11341 1.30649 9.17276 1.46687C9.40597 2.09712 9.90288 2.59403 10.5331 2.82724C10.6935 2.88659 10.6935 3.11341 10.5331 3.17276C9.90288 3.40597 9.40597 3.90288 9.17276 4.53313C9.11341 4.69351 8.88659 4.69351 8.82724 4.53313C8.59403 3.90288 8.09712 3.40597 7.46687 3.17276C7.30649 3.11341 7.30649 2.88659 7.46687 2.82724C8.09712 2.59403 8.59403 2.09712 8.82724 1.46687Z"
      fill="currentColor"
    />
  </svg>
);
export default UseAi;
